import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import CuratedContentCarouselCard from 'Components/UI/Carousel/CuratedContentCarouselCard';
import CuratedContentCarouselCardSkeleton
  from 'Components/UI/Carousel/CuratedContentCarouselCard/CuratedContentCarouselCardSkeleton';
import {
  useDashboardContext,
} from 'Views/Dashboard/DashboardContext';
import { FDContentContainer } from '@facet-wealth/design';
import useHomeContext from 'Context/HomeContext';

const styles = (theme) => ({
  root: {},
  rootWhiteBackground: {
    backgroundColor: theme.palette.common.white,
  },
  curatedContentSection: {
    padding: theme.spacing(4, 2),
  },
  cardContainer: {
    display: 'flex',
    overflow: 'auto',
    padding: theme.spacing(2),
    gap: `${theme.spacing(3)}px`,
  },
  card: {
    boxShadow: theme.shadows[4],
  },
});

const CuratedContentSection = ({
  className,
  classes,
}) => {
  const { hasLegacyDashboardImprovement } = useHomeContext();
  const { clientDashboardResource, isInitializing } = useDashboardContext();
  const articles = clientDashboardResource?.attr('curatedContentArticles')?.resources()?.list() || [];

  return (
    <div
      className={classNames(classes.root, className, {
        [classes.rootWhiteBackground]: !hasLegacyDashboardImprovement,
      })}
    >
      <section className={classes.curatedContentSection} test="dashboard-curated-content-section">
        <FDContentContainer maxWidth="xl">
          <Typography
            color="black"
            variant="h4"
            weight="bold"
          >{'For you'}
          </Typography>
          <div className={classes.cardContainer}>
            {!isInitializing
              ? articles.map(el => (
                <CuratedContentCarouselCard resource={el} className={classes.card} />
              ))
              : Array(5).fill(0).map(() => (
                <CuratedContentCarouselCardSkeleton />
              ))}
          </div>
        </FDContentContainer>
      </section>
    </div>
  );
};

CuratedContentSection.defaultProps = {
  className: '',
};

CuratedContentSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CuratedContentSection);
